/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { OrganizationProjectList } from 'src/app/common/fancy-firebase/lists/OrganizationProjectList';
import { OrganizationProject } from '../models/OrganizationProject';

export class OrganizationProjectsApi extends FancyActionableFirebase<
	OrganizationProject,
	FancyAction,
	OrganizationProjectList
> {
	constructor(public data: OrganizationProjectList) {
		super(data);
	}
}
